export default __webpack_public_path__ + "static/media/1.77935664.png";